import styled, { css } from 'styled-components';

export const Header = styled.div`
  ${({ theme }) => css`
    padding: 16px 24px;
    border-radius: 16px 16px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 16px;
    }
  `}
`;

export const MaiaIcon = styled.img`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 100%;
    height: 32px;
    width: 32px;
  `}
`;

export const BetaTag = styled.span`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.brand.primaryLowLight};
    border-radius: 4px;
    color: ${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    height: 24px;
    justify-content: center;
    margin-left: 5px;
    padding: 0 8px;
    width: fit-content;
    position: absolute;
    top: 16px;
    left: 24px;
  `}
`;

export const TitleWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      margin-top: 24px;
      gap: 4px;
    }
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.v2.colors.white.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 120%;
    margin: 0;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm};
      text-align: center;
    }
  `}
`;
